import { Field, RichTextField, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { AccordionContent, AccordionItem, AccordionTrigger } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import {
  AnchorTargetParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

type C01AccordionItemProps = RenderingProps<
  C01AccordionItemFields,
  C01AccordionItemRenderingPramas
>;

type C01AccordionItemFields = {
  Title?: Field<string>;
  BodyCopy?: RichTextField;
};

type C01AccordionItemRenderingPramas = TranslationOptionsParams & AnchorTargetParams;

export const Default = (props?: C01AccordionItemProps): JSX.Element => {
  const { renderRichText } = useConditionalRendering();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <AccordionItem
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      value={props.rendering?.uid || ''}
      data-component={marketingRenderingName}
    >
      <AccordionTrigger>
        <Text field={props?.fields?.Title} />
      </AccordionTrigger>
      <AccordionContent>{renderRichText(props?.fields?.BodyCopy)}</AccordionContent>
    </AccordionItem>
  );
};
